<mf-page title="Editar Orden de Cobro">
  @if (collectOrderDto) {
  <mf-collect-order
    [collectOrderDto]="collectOrderDto"
    (close)="close()"
    (save)="save($event)" />
  }
</mf-page>
